import templateOnlyComponent from '@ember/component/template-only';

interface AditoolsContentWrapSignature {
  Element: HTMLDivElement;
  Blocks: {
    default: [];
  };
}

const AditoolsContentWrap = templateOnlyComponent<AditoolsContentWrapSignature>();

export default AditoolsContentWrap;
